// GENERATED AUTOMATICALLY
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AntdIcon, { AntdIconProps } from '../components/AntdIcon';
import { IconDefinition } from '../types';

const FillDripOutlinedSvg: IconDefinition = {"icon":{"tag":"svg","attrs":{"viewBox":"0 0 576 512","focusable":"false"},"children":[{"tag":"path","attrs":{"d":"M39 7a24.2 24.2 0 0134 0l89.4 89.4 58.7-58.7a72 72 0 01101.8 0l151.4 151.4a72 72 0 010 101.8L283.9 481.4a96.03 96.03 0 01-135.8 0L30.6 363.9a96.03 96.03 0 010-135.8l97.8-97.8L39 41a24.2 24.2 0 010-34zm192 226l-68.7-68.7-97.7 97.8A47.8 47.8 0 0051.2 288h358.2l31-31a23.9 23.9 0 000-33.9L289 71.6a23.9 23.9 0 00-33.9 0l-58.7 58.7L265 199c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0zm281 279c-35.3 0-64-28.7-64-64 0-25.2 32.6-79.6 51.2-108.7 6-9.4 19.5-9.4 25.5 0C543.4 368.4 576 422.8 576 448c0 35.3-28.7 64-64 64z"}}]},"name":"fill-drip","theme":"outlined"};

const FillDripOutlined = (
  props: AntdIconProps,
  ref: React.MutableRefObject<HTMLSpanElement>,
) => <AntdIcon {...props} ref={ref} icon={FillDripOutlinedSvg} />;
  FillDripOutlined.displayName = 'FillDripOutlined';

export default React.forwardRef<HTMLSpanElement, AntdIconProps>(FillDripOutlined);
